export default "__VITE_ASSET__CHNcczvY__"